import { useCallback } from "react";
import sendCapabilityUsedEvent from "../sendCapabilityUsedEvent";
/**
 * Returns `raiseEventCapabilityIsUsed(capabilityKey)`, the one call a usage spot makes. A capability check
 * answers whether the Feature should be shown; call this only on the real User action. The returned
 * function keeps a stable identity between renders, so it is safe in a dependency array.
 */
export default function useEventCapabilityIsUsed() {
    return useCallback((capabilityKey) => sendCapabilityUsedEvent(capabilityKey), []);
}
